angular.module('lead')
    .constant('SalesTeamEvents', {
        updated: 'sales-team.updated'
    })
    .factory('SalesTeam', function ($resource) {
        return $resource('/crm/api/sales-team/:id', {id: '@id'}, {
            list: {method: 'GET'},
            get: {method: 'GET'},
            update: {method: 'PUT'},
            remove: {method: 'DELETE'}
        });
    })
    .service('SalesTeamService', function ($rootScope, modals, SalesTeam, SalesTeamEvents) {
        this.add = () => this.edit({active: true, accessScope: 'TEAM_MEMBERS', users: [], projects: []});
        this.edit = item => modals.open('app/lead/team/sales-team-edit-modal.html', 'SalesTeamEditController', angular.copy(item), {size: 'md'}, '$ctrl');
        this.remove = item => modals.confirmDelete(item.name, () => SalesTeam.remove({id: item.id}).$promise.then(() => $rootScope.$broadcast(SalesTeamEvents.updated)));
    })
    .component('salesTeamList', {
        bindings: {
            page: '<',
            filters: '<'
        },
        templateUrl: 'app/lead/team/sales-team-list.html',
        controller: function ($scope, $state, SalesTeamService, SalesTeamEvents) {
            this.salesTeamService = SalesTeamService;
            this.reset = () => this.filters = {};
            $scope.$on(SalesTeamEvents.updated, () => $state.reload());
        }
    })
    .controller('SalesTeamEditController', function ($rootScope, $uibModalInstance, $translate, data, toastr, SalesTeam, SalesTeamEvents) {
        const ctrl = this;
        ctrl.item = data;
        ctrl.cancel = () => $uibModalInstance.dismiss('cancel');
        ctrl.save = () => {
            const request = ctrl.item.id ? SalesTeam.update({id: ctrl.item.id}, ctrl.item).$promise : SalesTeam.save(ctrl.item).$promise;
            return request.then(saved => {
                toastr.success($translate.instant('sales-team.saved'));
                $rootScope.$broadcast(SalesTeamEvents.updated);
                $uibModalInstance.close(saved);
            });
        };
    })
    .controller('SalesTeamHelpController', function ($document, $window) {
        this.scrollTo = sectionId => {
            const section = $document[0].getElementById(sectionId);
            if (section == null) {
                return;
            }
            const prefersReducedMotion = $window.matchMedia && $window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            section.scrollIntoView({behavior: prefersReducedMotion ? 'auto' : 'smooth', block: 'start'});
            section.focus({preventScroll: true});
        };
    })
    .config(function ($stateProvider) {
        $stateProvider.state('salesTeamList', {
            parent: 'app',
            url: '/lead/sales-teams?{page:int}&{size:int}&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_LEADS_SETTINGS']
            },
            views: {
                'content@': 'salesTeamList'
            },
            resolve: {
                filters: $stateParams => angular.copy($stateParams),
                page: (SalesTeam, $stateParams) => SalesTeam.list(angular.copy($stateParams)).$promise
            }
        });
        $stateProvider.state('salesTeamHelp', {
            parent: 'app',
            url: '/lead/sales-teams/help',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_LEADS_SETTINGS']
            },
            views: {
                'content@': {
                    templateUrl: 'app/lead/team/sales-team-help.html',
                    controller: 'SalesTeamHelpController',
                    controllerAs: '$ctrl'
                }
            }
        });
    });
